// import Popconfirm from "antd/es/popconfirm";
// import Button from "antd/es/button";
import Alert from "antd/es/alert";
import React from "react";
import ReactPlayer from "react-player/youtube";
// import http from "../utils/http";
import BkpmLogo from "../../src/assets/bkpm-logo-new.png";
import OssLogo from "../../src/assets/oss-logo-new.png";
import WaitingImage from "../../src/assets/dont-refresh.png";
import WaitingImage1 from "../../src/assets/silakan-tunggu.png";
import InfoRed from "../../src/assets/info-red.png";
import WarningWhite from "../../src/assets/warning-white.png";
import useIsMobile from "../utils/useIsMobile";

export default function Queue({
  // queue,
  // setWaiting,
  // handleLogout,
  wording,
  response,
  platform,
  resCode,
}) {
  const isMobile = useIsMobile();
  React.useEffect(() => {
    if (response?.room?.uniqueName) {
      if (platform) {
        localStorage.setItem("sid-vonage", response.room.uniqueName);
      } else {
        localStorage.setItem("sid", response.room.uniqueName);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [response?.room?.uniqueName]);

  return (
    <div className="wrapper">
      <div
        className="inqueue"
        style={{
          boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.2)",
        }}
      >
        <div className="inqueue-body">
          {process.env.REACT_APP_LINK_VIDEO_ID ? (
            <ReactPlayer
              url={`https://www.youtube.com/watch?v=${process.env.REACT_APP_LINK_VIDEO_ID}`}
              loop={true}
              controls={false}
              width={"100%"}
              height={"250px"}
              playing={true}
            />
          ) : process.env.REACT_APP_LINK_LOGO ? (
            // <img
            //   src={process.env.REACT_APP_LINK_LOGO}
            //   style={{
            //     width: "100%",
            //     height: 150,
            //     objectFit: "contain",
            //     marginTop: 10,
            //     marginBottom: 10,
            //   }}
            //   alt="Logo BKPM"
            // />
            <div
              className="App-Card-Header"
              style={{
                justifyContent: "center",
                gap: 100,
              }}
            >
              <div className="App-Image">
                <img
                  src={BkpmLogo}
                  alt="Logo"
                  style={{
                    maxHeight: "100%",
                    maxWidth: "100%",
                  }}
                />
              </div>
              <div className="App-Logo">
                <img
                  src={OssLogo}
                  alt="Logo"
                  style={{
                    maxHeight: "100%",
                    maxWidth: "100%",
                  }}
                />
              </div>
            </div>
          ) : null}
          <div style={{ textAlign: "center" }}>
            <h5 style={{ fontWeight: 600 }}>
              Selamat datang di layanan video call Kementerian Investasi dan
              Hilirisasi/BKPM
            </h5>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div style={{ width: !isMobile ? "20%" : "50%" }}>
                <img
                  src={resCode === 1 ? WaitingImage : WaitingImage1}
                  alt="Waiting"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                  }}
                />
              </div>
            </div>
            <div
              className="label-status"

              style={{
                background: "#273244",
                color: "#fff",
                fontSize: !isMobile ? ".9rem" : ".7rem",
              }}
            >
              {wording}
            </div>
          </div>
          <div className="inqueue-wording">
            <div
              style={{
                display: "flex",
              }}
            >
              <div className="col-text" style={{ width: "100%" }}>
                {resCode === 1 ? (
                  <div
                    style={{
                      backgroundColor: "#A70008",
                      color: "white",
                      width: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 20,
                      margin: "0 auto",
                      padding: "10px 0",
                      borderRadius: 8,
                    }}
                  >
                    <div style={{ width: "60px" }}>
                      <img
                        src={WarningWhite}
                        alt="Info"
                        style={{
                          maxWidth: "100%",
                          maxHeight: "100%",
                        }}
                      />
                    </div>
                    <div
                      style={{
                        fontSize: 12,
                        fontWeight: "500",
                        lineHeight: 2,
                      }}
                    >
                      Petugas akan segera menyapa Anda.
                      <br />
                      Mohon tidak merefresh halaman ini.
                      <br />
                      Merefresh akan mengakibatkan sesi konsultasi berakhir.
                    </div>
                  </div>
                ) : (
                  <>
                    Bapak/Ibu yang kami hormati, layanan akan dimulai sesuai
                    dengan jadwal yang telah ditetapkan.
                    <br /> Mohon menunggu Anda akan segera terhubung dengan
                    petugas kami.
                    <br />
                    <br />
                    Hormat Kami,
                    <br />
                    Kementerian Investasi dan Hilirisasi/BKPM
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            borderTop: "3px solid #D90915",
          }}
        >
          <Alert
            style={{
              background: "#DADADA",
              padding: "20px 30px",
              textAlign: "center",
            }}
            message={
              <div
                style={{
                  display: "flex",
                  gap: 10,
                  justifyContent: "center",
                }}
              >
                <div style={{ width: "20px" }}>
                  <img
                    src={InfoRed}
                    alt="Info"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                    }}
                  />
                </div>
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: "500",
                  }}
                >
                  Guna meningkatkan kualitas layanan, panggilan video ini akan
                  direkam. Dilarang untuk merekam dan/atau menyebarluaskan audio
                  dan gambar. <br />
                  Pelanggaran akan ditindak sesuai dengan peraturan
                  perundang-undangan yang berlaku.
                </span>
              </div>
            }
            banner
            showIcon={false}
          />
        </div>
      </div>
    </div>
  );
}
